<template>
  <div>

    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group class="float-right">
        <el-button type="info" size="small" class="YeniBtn" @click="this.YeniBtn">{{ Sayfa.ButtonAdi }}
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <div class="SpotlightKutu">
        <div class="input">
          <el-input
            :disabled="lo"
            placeholder="Cari Unvan, Telefon veya Vergi Kimlik No ile arama yapın, tamamı için boş bırakın (ENTER'A BASIN)"
            v-model="Kelime"
            @keyup.enter.native="Getir">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-table
        v-if="Liste"
        :data="Liste"
        :default-sort="{prop: 'Unvan', order: 'ascending'}"
        class="golgetable"
        :height="Height"
      >
        <el-table-column
          label="Ünvan"
          prop="Unvan"
        >
        </el-table-column>
        <el-table-column
          label="Telefon"

          prop="Telefon">
        </el-table-column>
        <el-table-column
          label="Mail"
          prop="Mail">
        </el-table-column>
        <el-table-column
          align="right">
          <template slot-scope="scope">
            <el-button-group>

              <el-tooltip v-if="Yetki" class="item" effect="dark" :content="Sayfa.DuzenleAdi"
                          placement="top-start">
                <i
                  class="feather-edit-2  tableibtn text-primary"
                  @click="DuzenleBtn(scope.row)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="Sayfa.EkranAdi"
                          placement="top-start">
                <i
                  class="feather-airplay tableibtn text-success"
                  @click="$router.push('/muhasebe/cari/'+scope.row.id)">
                </i>

              </el-tooltip>
              <el-tooltip v-if="Yetki" class="item" effect="dark"
                          :content="Sayfa.SilAdi"
                          placement="top-start">
                <i
                  class="feather-trash tableibtn text-danger"
                  @click="SilOnay(scope.row.id)">
                </i>
              </el-tooltip>


            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <div class="ekranbos" v-if="!Liste"></div>
    </div>
    <FormModal :data="FormData" :ModalOlayi="ModalOlayi" :Baslik="Baslik"
               @ModalOlayi="SayfaYukle"></FormModal>
  </div>
</template>

<script>
import FormModal from "../../../components/Pack/Muhasebe/cari/FormModal";
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor, FormModal},
  data() {
    return {
      lo: false,
      Height: window.innerHeight - 180,
      Kelime: '',
      Yetki: false,
      ModalOlayi: false,
      Baslik: null,
      Sayfa: {
        ButtonAdi: 'Cari Ekle',
        DuzenleAdi: this.$t('eGenel.10'),
        SilAdi: this.$t('eGenel.11'),
        Button: null,
        EkranAdi: 'Cari Detay',
        Adi: 'Cari Listesi',
        Menu: [],
        MenuDisplay: null,
      },
      Liste: null,
      FormData: {
        Unvan: null,
        Telefon: null,
        Mail: null,
        Adres: null,
        vNo: null,
        vDairesi: null,
        bBilgi: {
          Adi: null,
          Iban: null
        },
      },

    }
  },
  methods: {
    SayfaYukle() {
      this.ModalOlayi = false;
    },
    Getir() {
      this.ModalOlayi = false;
      this.lo = true;
      this.$store.dispatch("Get", {path: 'muhasebe/cari/arama/' + this.Kelime})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Liste = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.Yetki = this.$store.getters.Yetki.muhasebe == 2 ? true : false;
    },
    SilOnay(id) {
      this.$confirm('Bütün ödemeler, borçlar ve ilgili kayıtları silinecektir.', this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Sil(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    Sil(id) {
      this.lo = true;
      this.$store.dispatch("Delete", {...this.Form, path: 'muhasebe/cari/' + id})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.ModalOlayi = false;
            this.$message.success(response.Mesaj);
            this.SayfaYukle();
          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },
    YeniBtn() {
      this.ModalOlayi = true;
      this.Baslik = 'Cari Ekle';
      this.FormData = {
        Unvan: null,
        Telefon: null,
        Mail: null,
        Adres: null,
        vNo: null,
        vDairesi: null,
        bBilgi: {
          Adi: null,
          Iban: null
        },
      }
    },
    DuzenleBtn(Veri) {
      this.FormData = Veri;
      this.Baslik = Veri.Unvan + ' Düzenle';
      this.ModalOlayi = true
    },
  },
  mounted() {
    this.$store.commit("SayfaBilgi", this.Sayfa);
    //console.log(this.Sayfa);
    this.SayfaYukle();

  }
}
</script>

<style scoped>
.SpotlightKutu {
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/pages/Muhasebe/cari/Liste.vue